/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IRCreateIRResponse } from "./IRCreateIRResponse";

export type IRCreateIRResponseApiRespoonse = {
  data?: IRCreateIRResponse;
  status?: IRCreateIRResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace IRCreateIRResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
